export default __webpack_public_path__ + "images/instagram-00799346ce02d2c041233ba7728d1c4e.svg";